export default __webpack_public_path__ + "static/media/right.a59ad72a.svg";